import { GO_BOARD_GRID_LINE_INDEXES, MOKA_MATCH_COLUMN_LABELS } from "@/constants";
const getMokaCoordinateLabel = coordinate => `${MOKA_MATCH_COLUMN_LABELS[coordinate.column]}${GO_BOARD_GRID_LINE_INDEXES.length - coordinate.row}`;
export { getMokaCoordinateLabel };